export const weatherFeatures = [
  {
    "id": "weather-data-in-excel",
    "title": "Need This Data in Excel?",
    "description": "Quickly load weather data right into Excel. Download as XLSX, CSV, or use our Excel add-in for seamless access.",
    "icon": "weather-data-in-excel.png",
    "color": "primary",
    "target": "_self",
    "url": "/excel-weather/"
  },
  {
    "id": "analyze-weather-data-tools",
    "title": "Want To Analyze This Data Further?",
    "description": "Effortlessly load weather data into your favorite tools. Download in CSV, XLSX, or JSON for use in any analysis platform.",
    "icon": "analyze-weather-data-tools.png",
    "color": "primary",
    "target": "_self",
    "url": "/weather-query-builder/"
  },
  {
    "id": "weather-data-in-database",
    "title": "Want This Weather Data in Your Database?",
    "description": "Easily integrate weather data into your database. Export as CSV and import with our how-to guides and scripts.",
    "icon": "weather-data-in-database.png",
    "color": "primary",
    "target": "_self",
    "url": "/resources/documentation/weather-data-tutorials/how-to-load-historical-weather-data-into-any-database/"
  },
  {
    "id": "monitor-multiple-locations",
    "title": "Need to Monitor Multiple Locations?",
    "description": "Use our free Query Builder to track multiple sites. Save queries and schedule automatic updates to stay informed.",
    "icon": "monitor-multiple-locations.png",
    "color": "primary",
    "target": "_self",
    "url": "/weather-query-builder/"
  },
  {
    "id": "additional-weather-elements",
    "title": "Want Additional Weather Elements?",
    "description": "Explore dozens of detailed weather metrics. Solar energy, visibility, air quality, snow, hail, cloud cover, and more.",
    "icon": "additional-weather-elements.png",
    "color": "primary",
    "target": "_self",
    "url": "/weather-query-builder/"
  },
  {
    "id": "solar-energy-weather-data",
    "title": "Need Data for Solar Energy Analysis?",
    "description": "Access key metrics for accurate solar modeling. GHI, DNI, sun elevation, UV index, and more available globally.",
    "icon": "solar-energy-weather-data.png",
    "color": "primary",
    "target": "_self",
    "url": "/solar-energy/"
  },
  {
    "id": "agriculture-weather-analysis",
    "title": "Need Data for Agricultural Analysis?",
    "description": "Unlock precise weather metrics for agriculture. Soil temperature, moisture, GDD, evapotranspiration, and more.",
    "icon": "agriculture-weather-analysis.png",
    "color": "primary",
    "target": "_self",
    "url": "/agriculture-weather-data/"
  },
  {
    "id": "weather-summary-data",
    "title": "Need Weather Summary Data?",
    "description": "Summarize weather trends by event, month, or year. Spot patterns, track extremes, and compute custom metrics like frost dates.",
    "icon": "weather-summary-data.png",
    "color": "primary",
    "target": "_self",
    "url": "/resources/documentation/weather-data/introduction-to-weather-statistics-and-analysis/"
  },
  
  {
    "id": "smart-weather-decisions",
    "title": "Make Smart Weather Decisions",
    "description": "Plan confidently with global, accurate forecasts. Adapt your business strategy to every weather shift.",
    "icon": "smart-weather-decisions.png",
    "color": "primary",
    "target": "_self",
    "url": "/weather-data"
  },
  {
    "id": "weather-api-for-business",
    "title": "Weather API For Your Business",
    "description": "Set up quickly and start pulling weather data instantly. Access global forecasts and historical data via our powerful API.",
    "icon": "weather-api-for-business.png",
    "color": "primary",
    "target": "_self",
    "url": "/weather-api/"
  },
  {
    "id": "historical-forecast-data",
    "title": "Historical Forecast Weather Data",
    "description": "Analyze past forecasts just as users experienced them. Evaluate how forecast accuracy impacts decision-making.",
    "icon": "historical-forecast-data.png",
    "color": "primary",
    "target": "_self",
    "url": "/resources/documentation/weather-data/how-to-query-weather-forecasts-from-the-past-historical-forecasts/"
  },
  {
    "id": "historical-weather-statistics",
    "title": "Get Historical Weather Statistics",
    "description": "Explore decades of historical climate statistics. Try our preview tool with any monthly plan.",
    "icon": "historical-weather-statistics.png",
    "color": "primary",
    "target": "_self",
    "url": "/resources/documentation/weather-data/introduction-to-weather-statistics-and-analysis/"
  },
  {
    "id": "lowest-cost-weather-data",
    "title": "Lowest Cost Weather Data",
    "description": "Get 1,000 records per day free. After that, pay just $0.0001 per additional record.",
    "icon": "lowest-cost-weather-data.png",
    "color": "primary",
    "target": "_self",
    "url": "/weather-data-editions/"
  },
  {
    "id": "easiest-weather-api",
    "title": "Easiest Weather Data API",
    "description": "Get instant access with a single signup. Query forecasts, historical data, and current conditions all in one API.",
    "icon": "easiest-weather-api.png",
    "color": "primary",
    "target": "_self",
    "url": "/weather-api/"
  },
  {
    "id": "csv-json-output",
    "title": "Flexible Output: CSV or JSON",
    "description": "Get data in CSV or JSON for seamless integration. Use it in your apps, scripts, and tools without extra processing.",
    "icon": "csv-json-output.png",
    "color": "primary",
    "target": "_self",
    "url": "/weather-query-builder/"
  },
  {
    "id": "best-weather-tools",
    "title": "Best Weather Data Tools",
    "description": "Use Dashboards, Query Builder, and Schedulers. Query data easily and automate your weather insights.",
    "icon": "best-weather-tools.png",
    "color": "primary",
    "target": "_self",
    "url": "/weather-query-builder/"
  },
  {
    "id": "weather-data-excel",
    "title": "Weather Data for Excel",
    "description": "Download XLSX files or use our Excel add-in. Query live data using built-in Excel formulas.",
    "icon": "weather-data-excel.png",
    "color": "primary",
    "target": "_self",
    "url": "/excel-weather/"
  }
]
;

// Helper function to get random features
export function getRandomFeatures(count = 2) {
  const shuffled = [...weatherFeatures].sort(() => 0.5 - Math.random());
  return shuffled.slice(0, count);
}

// Helper function to get features by ID
export function getFeatureById(id) {
  return weatherFeatures.find(feature => feature.id === id);
}

// Helper function to get features by category
export function getFeaturesByKeyword(keyword) {
  return weatherFeatures.filter(feature => 
    feature.title.toLowerCase().includes(keyword.toLowerCase()) ||
    feature.description.toLowerCase().includes(keyword.toLowerCase())
  );
}